import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M8 1.778A6.22 6.22 0 0 0 1.778 8 .889.889 0 0 1 0 8a8 8 0 0 1 8-8 .889.889 0 1 1 0 1.778m7.111 5.333c.491 0 .889.398.889.889a8 8 0 0 1-8 8 .889.889 0 0 1 0-1.778A6.22 6.22 0 0 0 14.222 8c0-.49.398-.889.89-.889"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
